<div *ngrxLet="trafficLogsSearchBarStore.isLoading$ as isLoading">
    <avi-dropdown-options
        class="traffic-logs-search-bar-dropdown__options clr-wrapper"
        [options]="options"
        [optionTemplateRef]="optionTemplateRef"
        [width]="dropdownWidth"
        [height]="dropdownHeight"
        [busy]="isLoading"
        [hideIfNoOptions]="hideDropdownIfNoOptions"
        [noEntriesMessage]="noGroupbyOptionsMessage"
        [errorMessage]="(trafficLogsSearchBarStore.hasError$ | async) && l10nKeys.errorMessage | vtranslate"
        (onOptionSelect)="handleOptionSelect($event)"
        (onSubmit)="handleSubmit()"
        (onEscape)="onOptionsEscape.emit()"
    ></avi-dropdown-options>
</div>

<ng-template
    #operatorOptionTemplateRef
    let-value
>
    <div class="traffic-logs-search-bar-dropdown__operator-container">
        <span class="traffic-logs-search-bar-dropdown__operator-symbol"> {{ value.symbol }} </span>
        <span> {{ value.desc }} </span>
    </div>
</ng-template>

<ng-template
    #valueOptionTemplateRef
    let-value
>
    <div class="traffic-logs-search-bar-dropdown__groupby-container">
        <span class="traffic-logs-search-bar-dropdown__groupby-value"> {{ value.value }} </span>
        <span> {{ value.count }} ({{ value.percentage }}%) </span>
    </div>
</ng-template>
